import * as React from 'react';
import clsx from 'clsx';
import useMediaQuery from '@mui/material/useMediaQuery';
import { makeStyles, useTheme } from '@mui/styles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { ICON_ARROW_LEFT, ICON_ARROW_RIGHT } from '../_style';
import { Box, Hidden } from '@mui/material';


const sliderStyles = makeStyles((theme) => ({
  root: {
    margin: '0 auto',
    padding: '0 100px',
    width: '100%',
    maxWidth: 'calc(1400px + 200px)',
    height: '100%',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      padding: '0 10px',
    },
  },
  title: {
    marginBottom: 10,
    fontSize: 24,
    fontWeight: 600,
    color: theme.palette.text.title,
    [theme.breakpoints.down('md')]: {
      fontSize: 20,
    },
  },
  arrow: {
    width: 100,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    zIndex: 10,
    '&.left': {
      left: '-100px',
    },
    '&.right': {
      right: '-100px',
    },
    '&>div': {
      width: 50,
      height: 50,
      borderRadius: '99em',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.palette.shadow.main,
      cursor: 'pointer',
      transition: '.3s',
      '&:hover': {
        boxShadow: theme.palette.shadow.hover,
        '& svg': {
          color: theme.palette.icon.hover,
        },
      },
    },
  },
  iconArrow: {
    color: theme.palette.icon.main,
  },
  arrowHide: {
    opacity: '0.2'
  },
  box: {
    [theme.breakpoints.down('md')]: {
      paddingBottom: 10,
      overflowX: 'auto',
      overflowY: 'hidden',
      display: 'flex',
      columnGap: 10,
    },
  },
}));


// 向左/往前按鈕
const PrevArrow = (props) => {
  const classes = sliderStyles();
  return (
    <Box className={clsx(classes.arrow, 'left', props.arrowHide.prev ? '' : classes.arrowHide)}>
      <Box>
        <ICON_ARROW_LEFT
          classes={classes.iconArrow}
          onClick={props.onClick}
          size={{box: 'l', svg: 'l'}} 
        />
      </Box>
    </Box>
  );
}

// 向右/往後按鈕
const NextArrow = (props) => {
  const classes = sliderStyles();
  return (
    <Box className={clsx(classes.arrow, 'right', props.arrowHide.next ? '' : classes.arrowHide)}>
      <Box>
        <ICON_ARROW_RIGHT
          classes={classes.iconArrow}
          onClick={props.onClick}
          size={{box: 'l', svg: 'l'}} 
        />
      </Box>
    </Box>
  );
}


/* 輪播 */
export function SliderCom({title, data, items, variableWidth}) {

  const classes = sliderStyles();
  const theme = useTheme();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'), {noSsr: true});
  const mdOnly = useMediaQuery((theme) => theme.breakpoints.only('md'), {noSsr: true});
  const smOnly = useMediaQuery((theme) => theme.breakpoints.only('sm'), {noSsr: true});
  const xsOnly = useMediaQuery((theme) => theme.breakpoints.only('xs'), {noSsr: true});
  const matches = lgUp ? 'lg' : (mdOnly ? 'md' : (smOnly ? 'sm' : (xsOnly ? 'xs' : null)));

  const mdDown = useMediaQuery((theme) => theme.breakpoints.down('md'), {noSsr: true});

  const [arrowHide, setArrowHide] = React.useState({
    prev: false,
    next: true
  });

  const beforeChange = (oldIndex, newIndex) => {

    const sum = data.length;   
    const last = sum - items[matches];

    setArrowHide({
      prev: newIndex === 0 ? false : true,
      next: newIndex === last ? false : true
    });

  }

  var settings = {
    dots: false,
    infinite: false, // 循環
    speed: 500,
    slidesToShow: items.lg,
    slidesToScroll: items.lg,
    autoplay: false,
    prevArrow: <PrevArrow arrowHide={arrowHide} />,
    nextArrow: <NextArrow arrowHide={arrowHide} />,
    arrows: mdDown ? false : true,
    variableWidth: variableWidth ? variableWidth : false,
    responsive: [
      {
        breakpoint: theme.breakpoints.values.lg,
        settings: {
          slidesToShow: items.lg,
          slidesToScroll: items.lg,
        }
      },
      {
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: items.md,
          slidesToScroll: items.md
        }
      },
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          slidesToShow: items.sm,
          slidesToScroll: items.sm
        }
      },
      {
        breakpoint: theme.breakpoints.values.xs,
        settings: {
          slidesToShow: items.xs,
          slidesToScroll: items.xs
        }
      }
    ],
    beforeChange: beforeChange
  };


  return (
    <Box className={classes.root}>
      <Box component='h2' className={classes.title}>{title}</Box>
      <Box className={classes.box}>

        <Hidden mdDown>
          <Slider {...settings}>
            {data.map(item => (
              <Box key={item.key}>
                {item.obj}
              </Box>
            ))}
          </Slider>
        </Hidden>
        
        <Hidden mdUp>
          {data.map(item => (
            <Box key={item.key}>
              {item.obj}
            </Box>
          ))}
        </Hidden>

      </Box>
    </Box>
  )

}